<template>
	<el-card class="box-card">
		<template #header>
			<div class="card-header">
				<span>设置快递模板</span>
				<el-button class="button" @click="AddTemplate" type="success">添加快递</el-button>
			</div>
		</template>
		<div class="col">
			<el-table :data="list" border style="width: 100%" :header-cell-style="{'text-align':'center'}"
				:cell-style="{'text-align':'center'}">
				<el-table-column prop="id" label="编号"></el-table-column>
				<el-table-column prop="delivery_express" label="快递名称">
					<template #default="scope">
						<p style="cursor: pointer;color: red;" @click="handleInfo(scope.row)">
							{{scope.row.delivery_express}}
						</p>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="添加时间"></el-table-column>
				<el-table-column label="状态">
					<template #default="scope">
						<el-tag v-if="scope.row.express_status ==0" type="danger">关闭</el-tag>
						<el-tag v-if="scope.row.express_status ==1" type="success">开启中</el-tag>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="230">
					<template #default="scope">
						<el-button v-if="scope.row.express_status ==0" @click="changeStatus(scope.row)" type="success"
							size="mini">开启</el-button>
						<el-button v-if="scope.row.express_status ==1" @click="changeStatus(scope.row)" type="danger"
							size="mini">关闭</el-button>
						<el-button @click="ModifyTemplateDelivery(scope.row)" type="primary" size="mini">修改</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</el-card>
	<el-dialog :title="title" v-model="dialogFormVisible">
		<el-form :model="item" ref="form" :rules="rules">
			<el-form-item>
				<el-form-item label="快递名称" prop="delivery_express">
					<el-input placeholder="请填写快递名称" v-model="item.delivery_express" size="small"></el-input>
				</el-form-item>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="dialogFormVisible = false">取 消</el-button>
			<el-button type="primary" @click="submit()">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
	export default {
		data() {

			return {
				title: '添加快递',
				dialogFormVisible: false,
				list: [],
				delivery_template: [],
				item: {
					delivery_express: '',
				},
				rules: {
					delivery_express: [{
						required: true,
						message: '请填写快递名称',
						trigger: 'blur'
					}],
				},
			}
		},
		methods: {
			AddTemplate() {
				this.resetObj(this.item)
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			ModifyTemplateDelivery(val) {
				let temp = this.cloneObj(val);
				this.title = '编辑';
				this.item = temp;
				this.dialogFormVisible = true;
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			getDeliveryExpressTemplate() {
				let pst_id = this.$route.query.pst_id;
				this.httpPost({
					url: '/admin/product/productSetDeliveryExpressTemplate',
					data: {
						pst_id: pst_id
					}
				}).then((re) => {
					this.list = re.data;
					for (let i in re.data) {
						this.delivery_template.push(re.data[i].delivery_express);
					}
				})
			},
			handleInfo(val) {
				this.$router.push({
					path: '/main/productSetCountryTemplate',
					query: {
						pde_id: val.id,
					}
				})
			},
			changeStatus(val) {
				// this.loading = true;
				this.httpPost({
					url: '/admin/product/productSetDeliveryExpressTemplateStatus',
					data: {
						id: val.id,
						express_status: val.express_status
					}
				}).then((res) => {
					if (res.code == 1) {
						this.$message.success(res.msg);
					}
					// this.loading = false;
					this.getDeliveryExpressTemplate();
				})
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						if (this.delivery_template.indexOf(this.item.delivery_express.toUpperCase()) != '-1') {
							this.$message.error('快递名称已存在');
							return false;
						}
						this.httpPost({
							url: '/admin/product/productSetDeliveryExpressTemplateUpdate',
							data: {
								delivery_express: this.item.delivery_express,
								pst_id: this.$route.query.pst_id,
								id: this.item.id
							}
						}).then((re) => {
							if (re.code > 1) return this.alertWarn('错误')
							this.alertSuccess('成功')
							this.dialogFormVisible = false;
							this.resetObj(this.item)
							this.getDeliveryExpressTemplate();
						}).catch((err) => {
							this.alertWarn('失败')
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				})
			}
		},
		created() {
			this.fullscreenLoading = true;
			this.getDeliveryExpressTemplate();
		}
	}
</script>